/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Debt_Payment_TitleInputs */

const vi_customer_debt_payment_title = /** @type {(inputs: Customer_Debt_Payment_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thanh toán công nợ`)
};

/**

* @param {Customer_Debt_Payment_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_debt_payment_title = /** @type {((inputs?: Customer_Debt_Payment_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Debt_Payment_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_debt_payment_title(inputs)
});